module.exports = __webpack_public_path__ + "static/media/PF-2011Sumidero.b6b215b2.png";